import React from "react";
import {
  translateService,
  authService,
  commonService,
  stateService,
  sessionService
} from "./services/imports";
import oidcService from "./services/oidcService";
import linkSession from "./services/linkSessionService";
import SessionError from "./pages/session/sessionError";
import { states, stateEvents, defaults, verifyStatuses } from "./models/imports";
import Navigation from "./navigation";
import { Scrollbars } from 'react-custom-scrollbars';
import GraphqlClientService from './services/GraphqlClientService';

export default class MainComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
      sessionError: null, // { message (null: the generic text), organizationsUnavailable }
      retrying: false,
    };

    this.subscriptions = [
      commonService.registerCommonInterceptor(),
      authService.registerAuthInterceptor(),
    ];
  }

  //refresh on translate change
  //clear state on signout
  //if authorized get current user info
  //if authorized change lang else set en
  componentDidMount() {
    this.subscriptions.push(
      translateService.subscribe((_) => {

        this.forceUpdate();
      })
    );

    this.subscriptions.push(stateService.onEvent(stateEvents.scrollUp).subscribe(() => {
      this.defScrollbar.scrollTop(0);
      })
    );

    this.subscriptions.push(stateService.onEvent(stateEvents.signOut).subscribe((closeWSConnection) => {
      
      if(closeWSConnection) {
        GraphqlClientService.CloseConnection();
      }
        this.profileSub = null;
        stateService.clearState(null, false, states.allLocales);
      })
    );

    let initialize = (lang) => {
      if (!lang) {
        translateService.use(defaults.locale.value, defaults.locale.key);
      }
      this.setState({ initialized: true });
    };

    // the userInfo of a session, its language, and for a signed-in account its
    // workspaces and organizations (sessionService) before the app renders
    const applyUserInfo = (info) => {
      // a printed link's public view has no account, hence no language:
      // keep the page's own
      if (!info.localeId) {
        stateService.setState(states.userInfo, info);
        initialize();
        return;
      }

      translateService.use(info.localeId, info.localeCode, () => {
        stateService.setState(states.userInfo, info);
        initialize(info.localeId);
      }, () => {
        initialize();
      });
    };

    // The session could not start (share-prompt task 19): its page, unless a
    // document link's pages say why or the 401 handling signed out already
    const sessionFailed = (e) => {
      if (authService.hasLinkSession() || !authService.isAuthenticated()) {
        // a retry that ended the session: no error page left spinning
        this.setState({ sessionError: null, retrying: false });
        initialize();
        return;
      }
      const body = e && e.response && e.response.data;
      const problem = body && typeof body === "object" ? body : null;
      const type = problem && String(problem.type || "").split("/").pop();
      // v1: the envelope's errorMessage; v2: the problem's title; else generic
      const message = (e && e.customError && e.errorMessage) || (problem && problem.title) || null;
      this.setState({
        sessionError: { message, organizationsUnavailable: type === "ORGANIZATIONS_UNAVAILABLE" },
        retrying: false,
      });
      initialize();
    };

    const fn = () => {
      if (authService.isAuthenticated()) {
        authService.clearCache("userInfo");
        let userInfo = authService.userInfo();
        this.subscriptions.push(userInfo);

        userInfo.subscribe((res) => {
            if (!res || !res.success) {
              sessionFailed(res);
              return;
            }
            const info = res.data;

            if(info.userStatus != verifyStatuses.verified) {

              setTimeout(() => {
                GraphqlClientService.CloseConnection();
              }, 1000);
            }

            // a document link's session and an account not activated have no
            // workspaces to read
            const begin =
              authService.hasLinkSession() || info.userStatus != verifyStatuses.verified
                ? Promise.resolve(info)
                : sessionService.start(info);
            begin.then((started) => {
              this.setState({ sessionError: null, retrying: false });
              applyUserInfo(started);
            }, sessionFailed);
          },
          sessionFailed
        );


      } else {

        setTimeout(() => {
          if(!authService.isAuthenticated())
            GraphqlClientService.CloseConnection();
        }, 1000);
        initialize();
      }
    };

    // "Try again": the session again; for 503 ORGANIZATIONS_UNAVAILABLE the
    // Keycloak session is renewed first (a token that outlived the SSO
    // session reads as 503 until then)
    this.retrySession = () => {
      const unavailable = this.state.sessionError && this.state.sessionError.organizationsUnavailable;
      this.setState({ retrying: true });
      const renew = unavailable ? oidcService.refreshSingleFlight(true).catch(() => null) : Promise.resolve();
      renew.then(fn);
    };

    const setLocales = (locales) => {
      stateService.setState(states.allLocales, {allLocales: locales});
      translateService.locales = locales;
    };

    translateService.fetchLocales().then((resp) => {
      setLocales(resp.data.data);
    });

    // a document link's slot belongs to its document's pages only: a page
    // load anywhere else starts without it (task 7: never another document)
    linkSession.dropIfElsewhere(window.location.pathname);

    // finish a Keycloak callback / restore the stored session, then bootstrap
    authService.init().then(fn, fn);
  }

  //global catch for render error
  componentDidCatch(error, info) {
    console.error(error);
  }

  //free subscriptions
  componentWillUnmount() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe && sub.unsubscribe();
    }
    this.subscriptions = [];
    GraphqlClientService.CloseConnection();
  }

  render() {
    
    if (this.state.initialized && this.state.sessionError)
      return (
        <SessionError
          message={this.state.sessionError.message}
          retrying={this.state.retrying}
          onRetry={this.retrySession}
          onSignOut={() => authService.logout()}
        />
      );
    return this.state.initialized ? <Scrollbars hideTracksWhenNotNeeded={true} ref={sb => this.defScrollbar = sb} autoHide className="BodyListScrollbar" ><Navigation />  </Scrollbars> : null;
  
  }
}
